import { render, staticRenderFns } from "./WeekdaysDisplay.vue?vue&type=template&id=c2fc8b9c&scoped=true&"
import script from "./WeekdaysDisplay.vue?vue&type=script&lang=js&"
export * from "./WeekdaysDisplay.vue?vue&type=script&lang=js&"
import style0 from "./WeekdaysDisplay.vue?vue&type=style&index=0&id=c2fc8b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fc8b9c",
  null
  
)

export default component.exports